import { Card, Col, Popconfirm, Row, Tabs } from 'antd'
import CustomBreadCrumb from '../../../../components/Common/CustomBreadCrumb'
import Documents from '../../../../components/Common/Documents/DocumentsCont'
import History from '../../../../components/Common/History'
import CreateFreightModalCont from '../../../../components/Purchasing/Cargo/AddCargo/CreateFreightModalCont'
import CargoForm from '../../../../components/Purchasing/Cargo/CargoForm'
import CargoLinesCont from '../../../../components/Purchasing/Cargo/Lines/CargoLinesCont'
import DeliveryRouteCont from '../../../../components/Purchasing/Cargo/Routes/DeliveryRouteCont'
import style from '../../../../components/Sales/style.css'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CodeIcon from '../../../../elements/CodeIcon'
import CustomSpin from '../../../../elements/CustomSpin'
import LinkHeader from '../../../../elements/LinkHeader'
import Status from '../../../../elements/Status'
import CustomTable from '../../../../elements/Table/CustomTable'
import _ from 'lodash'
import Authentication from '../../../../modules/Authentication'
import { idMaker, strVal } from '../../../../modules/Utils'
import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

const ids = idMaker()

AddCargo.propTypes = {}
const auth = new Authentication()

function AddCargo (props) {
  const {
    type,
    submitting,
    updating,
    fetching,
    submit,
    fetch,
    update,
    formRef,
    cargo,
    remove,
    removing,
    isUpdatable,
    actions,
    handleActions,
    isConfirmed,
    isNew,
  } = props

  const SubmitButton = () => (
    <FooterButtons
      style={{ marginBottom: 10 }}
      remove={remove}
      removing={removing}
      isRemovable={!isConfirmed}
      submit={submit}
      update={update}
      submitting={submitting || updating}
      title={'Department'}
      isNew={isNew}
      isEdit={!isNew}
    />
  )
  const Operations = ({ delivery, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))
    if (ops.length > 0 && isConfirmed) {
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to Duplicate?`}
            onConfirm={() => handleActions('duplicate')}
            okText="Yes"
            cancelText="No">
            <a>Duplicate</a>
          </Popconfirm>
        </span>,
      )
    }

    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider"/>, curr]) : []}
      </div>
    )
  }

  const uniqDo = _.uniqBy(cargo.packages, 'deliveryOrder._id')
  return (
    <CustomSpin spinning={fetching}>
      {uniqDo.map((DO) => (
        <LinkHeader
          title={'Cargo'}
          type={'Delivery Order'}
          link={{
            pathname: `/purchasing/delivery/${_.get(DO, 'deliveryOrder._id', '').replace('deliveryOrder/', '')}/update`,
          }}
          code={_.get(DO, 'deliveryOrder.code')}
          name={_.get(DO, 'deliveryOrder.title')}
          visible={true}
        />
      ))}
      <Card>
        <Row className={style.pageHeader}>
          <CustomBreadCrumb
            items={[
              { text: 'Purchasing' },
              { text: 'Order' },
              { text: 'Delivery' },
              { text: 'Cargo', link: '#/purchasing/cargo/list' },
              { text: isNew ? 'New Cargo' : cargo.code },
            ]}
          />

          {isNew && <h2 className={style.title}>New Cargo Order</h2>}
          {!isNew && (
            <Fragment>
              <Col span={17}>
                <h3 className={style.title}>
                  <CodeIcon code={strVal(cargo, 'code')} title={'Delivery Code'}/>
                  <Status value={strVal(cargo, 'status')}/>
                  <Operations style={{ marginTop: '10px' }} delivery={cargo} status={strVal(cargo, 'status')}/>
                </h3>
              </Col>
                {isConfirmed && !cargo.locked && (
                  <Col span={7}>
                    <div style={{ marginTop: '40px' }}>
                    <CreateFreightModalCont {...{ selection: [cargo], selectionRawData: [cargo] }} />
                    </div>
                  </Col>
                )}
              <RefreshButton onClick={fetch}/>
            </Fragment>
          )}
        </Row>
      </Card>
      <Card className={style.contentCard}>
        <Tabs defaultActiveKey="form">
          <Tabs.TabPane tab="Details" key="form">
            <CargoForm ref={formRef} {...props} />
            <SubmitButton/>
          </Tabs.TabPane>
          <Tabs.TabPane disabled={isNew} tab="Route" key="route">
            <DeliveryRouteCont {...{ cargo, isUpdatable }} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Packing List" key="line">
            <CargoLinesCont {...{ cargo }} />
          </Tabs.TabPane>

          <Tabs.TabPane disabled={isNew} tab="FB" key="fb">
            <CustomTable
              data={_.get(cargo, 'freightBooking', [])}
              defaultPageSize={20}
              isFilterable={true}
              fetching={fetching}
              fetch={fetch}
              columns={[
                { Header: 'Index', accessor: 'index' },
                {
                  Header: 'Code',
                  accessor: 'code',
                  Cell: ({ value, original }) => (
                    <Link
                      target={'_blank'}
                      to={`/purchasing/Order/${_.get(original, '_id', '').replace('purchases/', '')}/update`}>
                      {value}
                    </Link>
                  ),
                },
                { Header: 'Title', accessor: 'title' },
              ]}
            />
          </Tabs.TabPane>

          <Tabs.TabPane disabled={isNew} tab="Files" key="files">
            <Documents key={cargo._rev} editable={true} footer={false} category={false} email={true} owner={cargo}/>
          </Tabs.TabPane>
          <Tabs.TabPane disabled={type !== 'edit'} tab="History" key="history">
            <History owner={cargo} key={cargo._rev} isArray={true}/>
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </CustomSpin>
  )
}

export default AddCargo
